import { render, staticRenderFns } from "./BlocoPSAeAtivosAmbientais.vue?vue&type=template&id=8d45f186&scoped=true&lang=pug"
import script from "./BlocoPSAeAtivosAmbientais.vue?vue&type=script&lang=js"
export * from "./BlocoPSAeAtivosAmbientais.vue?vue&type=script&lang=js"
import style0 from "./BlocoPSAeAtivosAmbientais.vue?vue&type=style&index=0&id=8d45f186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d45f186",
  null
  
)

export default component.exports